<template>
    <div>
		<div class="page-filter-box">
		    <el-row :gutter="20">		  
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.queryValue" class="input-with-select" size="small">
                        <el-select v-model="params.queryType" slot="prepend" placeholder="请选择">
                            <el-option label="推送名称" :value="1"></el-option>
                            <el-option label="推送ID" :value="2"></el-option>
                        </el-select>
                    </el-input>
                </el-col>     
		        <el-col :xs="24" :sm="12" :md="5" :lg="5" :xl="4">
		            <el-select v-model="params.searchType" placeholder="请选择" size="small">
						<el-option label="不限制发起终端" :value="-1"></el-option>
		                <el-option label="仅看管理后台的" :value="1"></el-option>
		                <el-option label="仅看经营平台的" :value="2"></el-option>
						<el-option label="仅看系统接口的" :value="3"></el-option>
		            </el-select>
		        </el-col>		        
		        <el-col :xs="24" :sm="12" :md="5" :lg="5" :xl="4" class="page-filter-btns">
		            <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
		            <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
		        </el-col>
		    </el-row>
		</div>
        <div class="page-btns-box">
            <el-button  type="primary"  size="small" @click="$router.push('/operation/messagePush/add')">推送官方消息</el-button>
        </div>
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
				<el-table-column label="发起终端" :min-width="110">
					<template slot-scope="scope">
					    <span v-if="scope.row.pushObjType <= 4 ">管理后台</span>					    
					    <span v-else-if="scope.row.pushObjType === 5">经营平台</span>
						<span v-else-if="scope.row.pushObjType === 11">系统接口</span>
					</template>
				</el-table-column>
                <el-table-column prop="id" label="推送ID" :min-width="110"></el-table-column>
                <el-table-column prop="title" label="推送名称" :min-width="150" show-overflow-tooltip></el-table-column>
                <el-table-column label="推送类型" :min-width="110">
                    <template slot-scope="scope">
                        <span v-if="scope.row.pushObjType === 1">演出</span>
                        <span v-else-if="scope.row.pushObjType === 2">众筹</span>
                        <span v-else-if="scope.row.pushObjType === 3">自定义</span>
                        <span v-else-if="scope.row.pushObjType === 4">巡演</span>
						<span v-else-if="scope.row.pushObjType === 5">粉丝通告</span>
						<span v-else-if="scope.row.pushObjType === 11">演出上新</span>
                    </template>
                </el-table-column>
				<el-table-column label="推送方式" :min-width="110">
				    <template slot-scope="scope">
				        <span v-if="scope.row.pushMode === 1">立即推送</span>
				        <span v-else-if="scope.row.pushMode === 2">定时推送</span>
				    </template>
				</el-table-column>
                <el-table-column prop="totalUser" label="推送人数" :min-width="110"></el-table-column>
                <el-table-column prop="readPushListNum" label="查看推送" :min-width="110"></el-table-column>
                <el-table-column prop="readPushDetailNum" label="查看详情" :min-width="110"></el-table-column>
                <el-table-column prop="createUserName" label="推送人" :min-width="110"></el-table-column>
                <el-table-column prop="createTime" label="推送时间" :min-width="150"></el-table-column>
                <el-table-column fixed="right" label="操作" :width="120">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="manage(scope.row)"  icon="el-icon-edit">管理</el-button>
						<el-button type="text" size="small" @click="del(scope.row.id)" icon="el-icon-delete">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0">
            </el-pagination>
        </div>
       
        <MessagePushDetail ref="messagePushDetail"></MessagePushDetail>
    </div>
</template>

<script>

import MessagePushDetail from './components/MessagePushDetail';

const defaultQuery = {
    pageNo: 1,   
    searchType: -1,
    queryType: 1,
    queryValue: ""
};

export default {
    components:{ MessagePushDetail},
    data(){
        return {
            data: [],
            dataList: [],
            params:{
                ...defaultQuery,
                pageNo: parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0])
            },
            listLoading: true
        }
    },
    mounted() {
        this.getDataList();
    },
    methods:{
        //获取列表
        async getDataList() {

            this.listLoading = true;

            const res = await this.$request({
                url: '/msg/push/list',
                method: 'post',
                data: this.params,
            }).catch(() => {
                return {data: {state: '0', msg: '请求错误'}};
            }).finally(() => {
                this.listLoading = false;
            });

            const { state, msg, result } = res.data;

            if(state !== '1') {
                return this.$message.error(msg || '请求失败');
            }

            this.data = result;
            this.dataList = result.result || [];
        },
		//搜索
		search() {
		    this.params.pageNo = 1;
		    this.getDataList();
		},
		//重置搜索
		reset() {
		    this.params = {
		        ...defaultQuery,
		        pageSize: this.params.pageSize,
		    };
		    this.getDataList();
		},
         //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
       
        // 管理
        manage(row) {
            const {id} = row;
            this.$refs.messagePushDetail.show(id);
        },
		//删除
		del(id) {
		    const _msg = "确定要删除吗?";
		    this.$confirm(_msg, "提示", {
		        type: "warning",
		        center: true,
		        closeOnClickModal: false
		    }).then(() => {
		        this.listLoading = true;
		        this.$request({
		            url: "/msg/push/cancel",
		            method: "POST",
		            params: { id: id},
		        })
		            .then((res) => {
		                const { state, msg } = res.data;
		                if (state == 1) {
		                    this.getDataList();
		                } else {
		                    this.$message.error(msg || "请求失败");
		                }
		            })
		            .catch(() => {
		                this.$message.error("请求错误");
		            })
		            .finally(() => {
		                this.listLoading = false;
		            });
		    });
		},
    }
}
</script>